import {i18n} from '@netx/core/i18n';
import {PERMISSION_TYPE} from './constants';

export const PERMISSION_ACTION = <const>{
	DISABLE: i18n.t('i18n.disablePermissions'),
	EDIT: i18n.t('i18n.editPermission'),
	ENABLE: i18n.t('i18n.enablePermissions'),
};

export const PERMISSION_CONFIRMATION = <const>{
	DISABLE: i18n.t('i18n.attributePermissionConfirmationDisable'),
	ENABLE: i18n.t('i18n.attributePermissionConfirmEnable'),
};

export const PERMISSION_MESSAGES = <const>{
	NO_PERMISSIONS: i18n.t('i18n.noPermissionsYet'),
};

export const PERMISSION_TITLES = <const>{
	EDIT: i18n.t('i18n.attributePermissions'),
};

export const PERMISSION_TYPE_LABEL: Record<
	typeof PERMISSION_TYPE[keyof typeof PERMISSION_TYPE],
	string
> = {
	[PERMISSION_TYPE.READ]: i18n.t('i18n.view'),
	[PERMISSION_TYPE.WRITE]: i18n.t('i18n.edit'),
};
